// extracted by mini-css-extract-plugin
export default {"wrapper":"MyInput_wrapper__2GZuG"};